module.exports = __webpack_public_path__ + "img/img-6.14a87195.png";